function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, watch } from "vue";
import { definePropType } from "@types-vue/props";
import FilterBar from "../filter/filter-bar.vue";
import { editPrioritySetting } from "@/api/creative/warning";
import { Message } from "element-ui";
import _ from "lodash";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        model: {
            type: definePropType(Object),
            required: true
        }
    },
    components: {
        FilterBar: FilterBar
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var loading = ref(false);
        var query = ref({});
        var handleChange = function(data, key) {
            if (_.isArray(data)) {
                data.forEach(function(item) {
                    // @ts-ignore
                    query.value[key][item.prop] = item.value;
                });
            } else {
                // @ts-ignore
                query.value[key][data.prop] = data.value;
            }
        };
        var handleClose = function() {
            if (!loading.value) {
                emit("update:visible", false);
            }
        };
        var handleSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return editPrioritySetting(query.value);
                        case 4:
                            Message.success("\u64CD\u4F5C\u6210\u529F");
                            loading.value = false;
                            handleClose();
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](1);
                            loading.value = false;
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        9
                    ]
                ]);
            }));
            return function handleSubmit() {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                query.value = _.cloneDeep(props.model);
            }
        }, {
            immediate: true
        });
        return {
            query: query,
            loading: loading,
            handleChange: handleChange,
            handleClose: handleClose,
            handleSubmit: handleSubmit
        };
    }
});
